export default "__VITE_ASSET__Bjar3uHl__"